import React from "react";
import { InsightForm } from ".";
import { ModelWrapper } from "../../../components";

const initialValues = {
  insightType: "image",
  insightImage: "",
  selectedImage: "",
  selectedVideo: "",
  selectedThumbnail: "",
  title: "",
  description: "",
  checkResolution: false,
};

function InsightFormModel({
  showModal,
  toggleModal,
  onSubmit,
  title,
  subtitle,
  state,
}) {
  if (!showModal) return null;
  return (
    <ModelWrapper
      toggleModal={toggleModal}
      title={title}
      subtitle={subtitle}
      error={state.error}
    >
      <InsightForm
        onSubmit={onSubmit}
        state={state}
        toggleModal={toggleModal}
        initialValues={initialValues}
      />
    </ModelWrapper>
  );
}

export default InsightFormModel;
